import { call, put, takeLatest } from "redux-saga/effects";
import { types, actions } from "reducers/frequentDestination/frequentDestination";
import { replace, push } from "connected-react-router";
import { actions as notificationActions } from "reducers/notification";
import * as frequentDestination from "middleware/frequentDestination";
import * as i18n from "util/i18n";

const sagas = [
    takeLatest(types.FREQUENT_DESTINATION_PRE_REQUEST, frequentDestinationPre),

    takeLatest(types.LOAD_LIST_REQUEST, loadListRequest),
    takeLatest(types.LOAD_MORE_REQUEST, loadMoreRequest),

    takeLatest(types.CREATE_REQUEST, frequentDestinationCreate),

    takeLatest(types.MODIFY_REQUEST, modifyFrequentDestinationRequest),
    takeLatest(types.DELETE_REQUEST, deleteFrequentDestination),
];

export default sagas;

function* frequentDestinationPre() {
    const response = yield call(frequentDestination.frequentDestinationPre);
    if (response.type === "W") {
        // yield put(actions.userInvitePreFailure());
        yield put(replace(`/`));
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["frequentDestination"]),
        );
    } else {
        yield put({
            type: types.FREQUENT_DESTINATION_PRE_REQUEST_SUCCESS,
            data: response.data.data,
        });
    }
}

function* loadListRequest(params) {
    const { filters } = params;
    const response = yield call(frequentDestination.loadListRequest, filters);

    if (response.type === "W") {
        yield put(actions.loadListFailure());
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["frequentDestination"]),
        );
    } else {
        yield put(actions.loadListSuccess(response.data.data));
    }
}

function* loadMoreRequest(params) {
    const { filters } = params;
    const response = yield call(frequentDestination.loadListRequest, filters);

    if (response.type === "W") {
        yield put(actions.loadListFailure());
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["frequentDestination"]),
        );
    } else {
        yield put(actions.loadListMoreSuccess(response.data.data));
    }
}

function* frequentDestinationCreate(params) {
    const { setSubmitting } = params.formikBag;
    const {
        number,
        idEnvironment,
        idFrequentDestination,
        localBank,
        name,
        productType,
        recipientDocumentType,
        recipientDocument,
        recipientDocumentCountry,
        recipientAddress,
        recipientName,
    } = params.params;

    const response = yield call(
        frequentDestination.createDestination,
        number,
        idEnvironment,
        idFrequentDestination,
        localBank,
        name,
        productType,
        recipientDocumentType,
        recipientDocument,
        recipientDocumentCountry,
        recipientAddress,
        recipientName,
    );

    setSubmitting(false);
    if (response.type === "W") {
        yield put(actions.createFailure());
        yield put(
            notificationActions.showNotification(
                // eslint-disable-next-line no-nested-ternary
                response.data.data
                    ? response.data.data.name
                        ? response.data.data.name
                        : response.data.message
                    : response.data.message,
                "error",
                ["frequentDestination.create"],
            ),
        );
    } else {
        yield put(
            notificationActions.showNotification(i18n.get("frequentDestination.create.success"), "success", [
                "frequentDestination",
            ]),
        );
        yield put(actions.createSuccess(response.data.data));
        yield put(replace(`/frequentDestination`));
    }
}

function* deleteFrequentDestination(params) {
    const response = yield call(frequentDestination.deleteRequest, params);
    if (response.type === "W") {
        yield put(actions.deleteFailure());
        if (response.data.code === "COR020W") {
            params.formikBag.setErrors(response.data.data);
        } else {
            yield put(
                notificationActions.showNotification(response.data.message, "error", [
                    "frequentDestination.detailModifyDelete",
                ]),
            );
        }
    } else {
        yield put(actions.deleteSuccess());
        yield put(
            notificationActions.showNotification(i18n.get("frequentDestination.delete.success"), "success", [
                "frequentDestination",
            ]),
        );
        yield put(push(`/frequentDestination`));
    }
}

function* modifyFrequentDestinationRequest(params) {
    const response = yield call(frequentDestination.modifyFrequentDestination, params);
    if (response.type === "W") {
        yield put(actions.modifyFailure());
        if (response.data.code === "COR020W") {
            yield put(
                notificationActions.showNotification(response.data.message, "error", [
                    "frequentDestination.detailModifyDelete",
                ]),
            );
        }
    } else {
        yield put(
            notificationActions.showNotification(i18n.get("frequentDestination.modify.success"), "success", [
                "frequentDestination",
            ]),
        );
        yield put(actions.modifySuccess());
        yield put(push(`/frequentDestination`));
    }
}
